import getPilotApiService from '../../api_services/PilotApiService';

/**
 * This config items are overridden from the backend to match the finalizers logic
 *
 * @TODO Remove all this logic from the Pilot API's finalizers and ConfigController and instead send the final state to the backend.
 * @TODO The backend validates gimbalAngleDegrees differently from the frontend - move the logic to the frontend
 */
export async function fetchConfig() {
  const config = await getPilotApiService().getConfig();

  PPKGeorefOptional = config.optionalGeoref;
  Validation.config.blurScoreThreshold = config.validation.blurScore.allowAverageScore;
  Validation.config.panoErrorThreshold = config.validation.uploadingFlow.pano.errorThreshold;
  Validation.config.scanErrorThreshold = config.validation.uploadingFlow.scan.errorThreshold;
}
